module.exports = __webpack_public_path__ + "ins01.png?2f1e3fd080bdf05aa45dfe382d9a0aa7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ins01.png
// module id = 152
// module chunks = 0